(function() {
  'use strict';

  var root = document.querySelector('[data-dsr-bioav]');
  if (!root) return;

  var scrubber = root.querySelector('[data-bioav-scrubber]');
  var timer = root.querySelector('[data-bioav-time]');
  var stdCapsule = root.querySelector('[data-capsule="standard"]');
  var drCapsule = root.querySelector('[data-capsule="drcaps"]');
  var stdDots = root.querySelectorAll('[data-cfu="standard"] [data-cfu-dot]');
  var drDots = root.querySelectorAll('[data-cfu="drcaps"] [data-cfu-dot]');

  if (!scrubber || !timer) return;

  var STANDARD_BREAK = 7;
  var DRCAPS_BREAK = 52;
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function render(minute) {
    timer.textContent = minute + ' min';

    // Standard capsule: disintegrates at 7 min
    if (minute >= STANDARD_BREAK) {
      if (stdCapsule) stdCapsule.style.opacity = Math.max(0, 1 - (minute - STANDARD_BREAK) / 8);
      var killProgress = Math.min(1, (minute - STANDARD_BREAK) / 10);
      stdDots.forEach(function(dot, i) {
        var delay = i * 0.08;
        var dotFade = Math.max(0, 1 - (killProgress - delay) * 2);
        dot.style.opacity = dotFade;
        dot.style.transform = 'translateY(' + (killProgress * 20) + 'px)';
      });
    } else {
      if (stdCapsule) stdCapsule.style.opacity = 1;
      stdDots.forEach(function(dot) {
        dot.style.opacity = 0.9;
        dot.style.transform = 'translateY(0)';
      });
    }

    // DRcaps: stays intact until 52 min, dots pulse alive
    if (minute >= DRCAPS_BREAK) {
      if (drCapsule) drCapsule.style.opacity = Math.max(0.3, 1 - (minute - DRCAPS_BREAK) / 10);
      drDots.forEach(function(dot) {
        dot.style.opacity = 1;
        dot.style.transform = 'scale(1.2)';
      });
    } else {
      if (drCapsule) drCapsule.style.opacity = 1;
      drDots.forEach(function(dot) {
        dot.style.opacity = 0.9;
        dot.style.transform = 'scale(1)';
      });
    }
  }

  scrubber.addEventListener('input', function() {
    render(parseInt(scrubber.value, 10));
  });

  render(0);

  // Auto-play when section visible; pause on hover/interaction
  if ('IntersectionObserver' in window && !prefersReducedMotion) {
    var autoPlayInterval = null;
    var userInteracted = false;
    var currentMinute = 0;

    function autoPlay() {
      if (userInteracted) return;
      currentMinute = (currentMinute + 1) % 61;
      scrubber.value = currentMinute;
      render(currentMinute);
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting && !userInteracted) {
          if (!autoPlayInterval) {
            autoPlayInterval = setInterval(autoPlay, 200);
          }
        } else {
          if (autoPlayInterval) {
            clearInterval(autoPlayInterval);
            autoPlayInterval = null;
          }
        }
      });
    }, { threshold: 0.4 });

    observer.observe(root);

    ['mouseenter', 'touchstart', 'focusin'].forEach(function(evt) {
      root.addEventListener(evt, function() {
        if (autoPlayInterval) {
          clearInterval(autoPlayInterval);
          autoPlayInterval = null;
        }
      });
    });

    scrubber.addEventListener('input', function() {
      userInteracted = true;
      if (autoPlayInterval) {
        clearInterval(autoPlayInterval);
        autoPlayInterval = null;
      }
    });
  }
})();
